import React, { memo } from 'react';
import Avatar from '../../../../../../../shared/design-system/components/atoms/initials-avatar';
import AiChatAvatar from '../../../../../../../assets/images/no-result-gradient.svg';

/**
 *
 * @param param0
 * @prop speaker -  The speaker identifier for to show AI avatar icon.
 * @prop firstName - First name of the user.
 * @prop lastName - Last name of the user.
 * @returns React Component
 */

const AiSpeakerAvatar: React.FC<{
  speaker: string;
  firstName?: string;
  lastName?: string;
}> = ({ speaker = '', firstName = '', lastName = '' }) =>
  speaker === 'saleshandy-copilot' ? (
    <div className="chat-avatar ai">
      <img src={AiChatAvatar} alt="Ai" className="ai-chat-avatar-image" />
    </div>
  ) : (
    <Avatar
      firstName={firstName}
      lastName={lastName}
      className="chat-avatar user"
    />
  );

export default memo(AiSpeakerAvatar);
